@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.label {
  color: var(--cxy-color-text-default-body);
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-3);
  content: attr(data-mobile-text);

  &.hasMobileText {
    span:first-child {
      display: block;
    }
    span:last-child {
      display: none;
    }

    @include cxy.screen-size('desktop') {
      span:last-child {
        display: block;
      }
      span:first-child {
        display: none;
      }
    }
  }
}

.size-s {
  @include cxy.font-size('text-xs');
  line-height: var(--cxy-lineHeight-xs);
}

.size-m {
  @include cxy.font-size('text-s');
}

.size-l {
  @include cxy.font-size('subHeading-l');
}
